<template>
    <b-modal :active.sync="show" id="contracttemplatesignaturemodal" aria-modal :width="600" :can-cancel="false">
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head"><p class="modal-card-title">Standaardhandtekening toevoegen</p></header>
            <section class="modal-card-body" style="border-radius:0" v-if="step === 1">
                <p>Het is mogelijk om een standaardhandtekening toe te voegen aan de template, zodat deze automatisch wordt opgenomen in elk document dat met deze template wordt aangemaakt. Wil je dit toevoegen?</p>
            </section>
            <section class="modal-card-body" style="border-radius:0" v-if="step === 2">
                <p>Teken de handtekening hieronder in het vlak en klik op bevestigen.</p>
                <VueSignaturePad id="signingpad" width="528px" height="200px" ref="signaturePad"/>
            </section>
            <footer class="modal-card-foot text-right">
                <div v-if="step === 1">
                    <b-button @click="$emit('close')">Nee, sluiten</b-button>
                    <b-button type="is-success" @click="step = 2">Ja, toevoegen</b-button>
                </div>
                <div v-else-if="step === 2">
                    <b-button @click="$emit('close'); step = 1;" :disabled="loading">Annuleren</b-button>
                    <b-button type="is-success" @click="submitSigning" :loading="loading" :disabled="loading">Bevestigen</b-button>
                </div>
            </footer>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'ContractTemplateSignatureModal',
    props: {
        record: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        index: {
            type: Number|null,
            required: true
        }
    },

    data() {
        return {
            loading: false,
            step: 1,
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        }
    },

    methods: {
        submitSigning() {
            this.loading = true

            const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
            if (!!isEmpty) {
                this.loading = false
                return
            }

            // Check if we have an organisation
            const organisation = !_.isNull(this.record.organisation) ? this.record.organisation : this.user.organisation
            if (!organisation){
                console.error('No organisation found')
                return false;
            }


            axios.post('/api/contract-templates/signature', {signature: data, organisation}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.$emit('passSignaturePath', response.data.path)
            }).catch((e) => {
                console.error('Something went wrong!', e)
            })

            this.step = 1
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss">
    #signingpad {
        border:2px solid #000;
    }
</style>